import { useGrowl } from "PFApp/use_growl";
import { LoadingDots } from "PFComponents/loading_dots";
import SidePanel from "PFComponents/side_panel/side_panel";
import { useCustomValue } from "PFCore/hooks/queries/custom_fields/admin";
import React from "react";
import { useTranslation } from "react-i18next";

import { useSkillManagementSidePanel } from "../../table/hooks/use_skill_management_side_panel";
import { useSkillsCustomTypeId } from "../../utils/use_skills_custom_type";
import { DescriptionSection } from "./description_section";
import { InfoBoxes } from "./info_boxes";
import { SidePanelActions } from "./side_panel_actions";
import { SkillsFrameworksSection } from "./skills_frameworks_section";
import css from "./skills_management_side_panel.module.scss";

export const SkillsManagementSidePanel = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { closeSidePanel, sidePanelSkillId, setSidePanelSkillId, isSidePanelOpen } =
    useSkillManagementSidePanel();
  const skillsCustomTypeId = useSkillsCustomTypeId();
  const growl = useGrowl();

  const { data: skill, isLoading } = useCustomValue(skillsCustomTypeId, sidePanelSkillId!, {
    enabled: sidePanelSkillId !== null,
    onError: () => {
      setSidePanelSkillId(null);
      growl({
        message: t("somethingWentWrong"),
        kind: "error"
      });
    }
  });

  if (sidePanelSkillId === null || (!isLoading && !skill)) {
    return null;
  }

  return (
    <SidePanel
      show={isSidePanelOpen}
      onClose={closeSidePanel}
      title={(skill?.value as string | undefined) || ""}
      fullHeight
    >
      {isLoading ? (
        <div className={css.sidePanelLoader}>
          <LoadingDots circlesEnabled circleSize="xs" />
        </div>
      ) : (
        <div className={css.sidePanelContent}>
          <InfoBoxes skill={skill} />
          <SidePanelActions skill={skill} />
          <DescriptionSection skill={skill} />
          <SkillsFrameworksSection skill={skill} />
        </div>
      )}
    </SidePanel>
  );
};
